function cov_1afyp9l03o() {
  var path = "/var/www/default/resources/js/main.js";
  var hash = "b3fa9598824d76351a3a9d044e9c40d0cb8d074b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/var/www/default/resources/js/main.js",
    statementMap: {
      "0": {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 38,
          column: 6
        }
      },
      "1": {
        start: {
          line: 34,
          column: 26
        },
        end: {
          line: 34,
          column: 63
        }
      },
      "2": {
        start: {
          line: 36,
          column: 12
        },
        end: {
          line: 36,
          column: 64
        }
      },
      "3": {
        start: {
          line: 40,
          column: 0
        },
        end: {
          line: 40,
          column: 28
        }
      },
      "4": {
        start: {
          line: 41,
          column: 0
        },
        end: {
          line: 41,
          column: 28
        }
      },
      "5": {
        start: {
          line: 42,
          column: 0
        },
        end: {
          line: 42,
          column: 27
        }
      },
      "6": {
        start: {
          line: 44,
          column: 0
        },
        end: {
          line: 44,
          column: 43
        }
      },
      "7": {
        start: {
          line: 46,
          column: 0
        },
        end: {
          line: 46,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 33,
            column: 17
          },
          end: {
            line: 33,
            column: 18
          }
        },
        loc: {
          start: {
            line: 33,
            column: 33
          },
          end: {
            line: 37,
            column: 9
          }
        },
        line: 33
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b3fa9598824d76351a3a9d044e9c40d0cb8d074b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1afyp9l03o = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1afyp9l03o();
/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

import './bootstrap';
import { createApp } from 'vue';
import Routes from '@/routes.js';
import App from '@/views/App.vue';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { store } from '@/store';
import { i18nVue } from 'laravel-vue-i18n';
const app = (cov_1afyp9l03o().s[0]++, createApp(App).use(Routes).use(Antd).use(VueAxios, axios).use(store).use(i18nVue, {
  lang: store.getters['user/locale'],
  resolve: async lang => {
    cov_1afyp9l03o().f[0]++;
    const langs = (cov_1afyp9l03o().s[1]++, import.meta.glob('../../lang/*.json'));
    cov_1afyp9l03o().s[2]++;
    return await langs[`../../lang/php_${lang}.json`]();
  }
}));
cov_1afyp9l03o().s[3]++;
dayjs.extend(isSameOrAfter);
cov_1afyp9l03o().s[4]++;
dayjs.extend(quarterOfYear);
cov_1afyp9l03o().s[5]++;
dayjs.extend(relativeTime);
cov_1afyp9l03o().s[6]++;
app.config.globalProperties.$dayjs = dayjs;
cov_1afyp9l03o().s[7]++;
app.mount('#app');